import React from 'react'

const relatoriosRoutes = [
    {
        path: '/relatorio/geral',
        exact: true,
        component: React.lazy(() => import('./geral/Table')),
    },
    {
        path: '/relatorio/resgates',
        exact: true,
        component: React.lazy(() => import('./resgates/Table')),
    },
    {
        path: '/relatorio/pontos',
        exact: true,
        component: React.lazy(() => import('./pontos/Table')),
    },
    {
        path: '/relatorio/anuncios',
        exact: true,
        component: React.lazy(() => import('./anuncios/Table')),
    },
    {
        path: '/relatorio/planos',
        exact: true,
        component: React.lazy(() => import('./planos/PlanosListIndex')),
    },
    {
        path: '/relatorio/planos/visualizar/:contratacaoId',
        exact: true,
        component: React.lazy(() => import('./planos/PlanosViewIndex')),
    },
]

export default relatoriosRoutes
